import React from "react";
import { FileUploader, Validator } from "devextreme-react";
// Validator
class FileUploaderField extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
    }
  }

  handleChange = (e) => {
    if (e.value && e.value.length) {

      if (!this.props.formats && !this.props.maxFileSize) {
        this.props.onChange(e);
        return;
      }

      let acceptedFiles = [];
      e.value.forEach(file => {
        const name = file.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        if (this.props.formats && file.type !== this.props.formats) {
          this.setState({ errorMessage: "El documento no tiene el formato correcto" })
          return;
        }

        if (this.props.maxFileSize && file.size >= this.props.maxFileSize) {
          this.setState({ errorMessage: "El documento es muy grande" })
          return;
        }

        if ((this.props.formats && file.type === this.props.formats)
          && (this.props.maxFileSize && file.size < this.props.maxFileSize)
        )
          acceptedFiles.push(new File([file], name, {
            type: file.type,
          }))
      });

      if (acceptedFiles.length) {
        this.props.onChange({
          value: acceptedFiles,
          element: {
            id: e.element.id
          }
        });

        e.value = [];
        this.setState({ errorMessage: "" })
      } else {
        e.component.option("value", [])
      }
      e.cancel = true;
    } else {
      e.cancel = true;
    }

  }

  render() {
    const {
      multiple,
      label,
      text,
      disabled,
      onChange,
      id,
      optional,
      onUploadStarted,
      uploadMode,
      uploadUrl,
      validar,
      required,
      formats,
      subLabel,
      ...rest
    } = this.props;


    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0 }}>
        {label ? <h3><p>{label}{required ? <span className="label-red-requerido"> *</span> : ""}</p></h3> : <div style={{ height: 35 }}></div>}
        {subLabel && <p style={{ fontSize: 14 }}>{subLabel}</p>}
        <FileUploader
          accept={formats || "*"}
          className="file-uploader"
          multiple={multiple}
          selectButtonText={text}
          disabled={disabled}
          onValueChanged={this.handleChange}
          uploadUrl={uploadUrl}
          uploadMode={uploadMode}
          onUploadStarted={onUploadStarted}
          id={id}
          {...rest}
        >
          {validar === true ? (
            <Validator
              elementAttr={{
                class: "custom-file-validator"
              }}
              onValidated={(e) => {
                if (!e.isValid && this.state.errorMessage === "") this.setState({ errorMessage: e.brokenRule.message })
              }}
              validationRules={[{
                type: "required",
                message: "Este campo es requerido",
              }]}
            />
          ) :
            <Validator
              validationRules={[]}
            />
          }
        </FileUploader>
        {this.state.errorMessage !== "" && <div className="file-error-message">
          <div className="icon-file-error"></div>
          {this.state.errorMessage}
        </div>}
      </div>
    );
  }
}

export default FileUploaderField;
